import { Routes, Route, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useStore } from './store/useStore'
import { auth } from './services/supabase'

// Pages
import LandingPage from './pages/LandingPage'
import Dashboard from './pages/Dashboard'
import Accounts from './pages/Accounts'
import Budget from './pages/Budget'
import Investments from './pages/Investments'
import CreditScore from './pages/CreditScore'
import AICoach from './pages/AICoach'
import Pricing from './pages/Pricing'
import Login from './pages/Login'
import Layout from './components/Layout'

function ProtectedRoute({ children }) {
  const user = useStore(s => s.user)
  if (!user) return <Navigate to="/login" replace />
  return children
}

export default function App() {
  const setUser = useStore(s => s.setUser)
  const setPlan = useStore(s => s.setPlan)

  useEffect(() => {
    // Listen for auth changes
    const { data: { subscription } } = auth.onAuthChange(async (event, session) => {
      if (session?.user) {
        setUser(session.user)
        // Fetch plan from DB
        const { data } = await import('./services/supabase').then(m => 
          m.db.getUserProfile(session.user.id)
        )
        if (data?.plan) setPlan(data.plan)
      } else {
        setUser(null)
        setPlan('free')
      }
    })
    return () => subscription.unsubscribe()
  }, [])

  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/pricing" element={<Pricing />} />

      {/* Protected app */}
      <Route path="/dashboard" element={
        <ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>
      } />
      <Route path="/accounts" element={
        <ProtectedRoute><Layout><Accounts /></Layout></ProtectedRoute>
      } />
      <Route path="/budget" element={
        <ProtectedRoute><Layout><Budget /></Layout></ProtectedRoute>
      } />
      <Route path="/investments" element={
        <ProtectedRoute><Layout><Investments /></Layout></ProtectedRoute>
      } />
      <Route path="/credit" element={
        <ProtectedRoute><Layout><CreditScore /></Layout></ProtectedRoute>
      } />
      <Route path="/ai-coach" element={
        <ProtectedRoute><Layout><AICoach /></Layout></ProtectedRoute>
      } />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
